/*
 * (c) Copyright, 2008-2014 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
/* global Ext, ENVS_API_HOST, ENVS_API_PATH, ENVS_NOTIFY_HOST, ENVS_NOTIFY_PATH */
// TODO: This is a temporary fix to get the app to load.  We need to figure out how to
const Notification = require('notification').default;
const KCService = require('kcservice').default;
// Ensure CoreModule is loaded before we load
require(['hvx/modules/CoreModule', 'hvx/modules/core-view/View'], (Core, View) => {
  require([
    'hvx/modules/MapModule', 'hvx/modules/DrawMenuModule',
    'hvx/modules/GeocodeModule', 'hvx/modules/UserProfileModule', 'hvx/modules/Sidebar',
    'hvx/modules/DataTree', 'hvx/modules/Toolbar',
    'hvx/modules/Graphs', 'hvx/modules/SloshExplorer',
    'hvx/modules/overhang',
    'hvx/modules/StormTrack', 'hvx/modules/Tracker',
    'hvx/modules/Training',
    'hvx/modules/pins', 'hvx/modules/SurgeFlag',
    'hvx/modules/TimingFlag', 'hvx/modules/TextAdvisory',
    'hvx/modules/CTTViewer', 'hvx/modules/SurgeViewer', 'hvx/modules/EvacuationDialog',
    'hvx/modules/Reports',
    'hvx/modules/TWOViewer', 'hvx/modules/RiskProfiles',
    'hvx/modules/DataPanel',
    'hvx/modules/ContextMenu', 'hvx/modules/macros',
    'hvx/modules/Leav', 'hvx/modules/ForecastModule',
    'hvx/modules/Constants', 'hvx/modules/Commands',
    'hvx/modules/StormSim', 'hvx/modules/PoiWindowModule',
    'hvx/modules/Legend', 
    'hvx/modules/Theme'],
  (MapModule, DrawMenuModule, GeocodeModule, UserProfile, Sidebar, DataTree, Toolbar, Graphs,
    SloshExplorer, Overhang, StormTrack, Tracker, Training,
    Pins, SurgeFlag, TimingFlag, TextAdvisory, CTTViewer, SurgeViewer, EvacuationDialog, Reports, TWOViewer, RiskProfiles, DataPanel,
    ContextMenu, Macros, Leav, Forecast, Constants, Commands, StormSim, PoiWindowModule, Legend, Theme) => {
      
    'use strict';
    
    const ks = new KCService();
    ks.init().then((authorized) => {
      if (!authorized) {
        return;
      }
      // ===== Auth: Inject Bearer token into API and notify HTTP requests only =====
      const tokenProvider = () => ks.getToken();

      const isApiOrNotifyRequest = (url) => {
        if (typeof url !== 'string') {
          return false;
        }
        return url.startsWith(ENVS_API_HOST + ENVS_API_PATH) ||
               url.startsWith(ENVS_NOTIFY_HOST + ENVS_NOTIFY_PATH);
      };

      // Intercept Ext.Ajax requests and add the auth header only for our own API/notify calls
      Ext.Ajax.on('beforerequest', (conn, options) => {
        const token = tokenProvider().token;
        if (token && isApiOrNotifyRequest(options.url)) {
          options.headers = options.headers || {};
          options.headers.Authorization = `Bearer ${token}`;
        }
      });

      // Proactively refresh the Keycloak token before it expires
      tokenProvider().onTokenExpired = () => {
        tokenProvider().updateToken(5).then((refreshed) => {
          if (!refreshed) {
            console.warn('Token could not be refreshed');
          }
        });
      };

      // Patch native fetch() for the ~18 calls that use it
      const origFetch = window.fetch;
      window.fetch = function(url, options) {
        options = options || {};
        const token = tokenProvider().token;
        if (token && isApiOrNotifyRequest(url)) {
          options.headers = options.headers || {};
          options.headers.Authorization = `Bearer ${token}`;
        }
        return origFetch.call(this, url, options);
      };
      // ===== End auth header injection =====

      // start of the app
    console.log('KCService', ks);
    Ext.onReady(() => {
        
      Ext.QuickTips.init();
      console.log(ks.getToken());  
      // Instantiate the View
      const view = new View();
      const theme = new Theme();

      // eslint-disable-next-line no-unused-vars
      const notification = new Notification();
    
      // run 3 times to test the notification
      
      // notification.showAll();
      // view.remove('cBottomPanel');
      Ext.getCmp('cBottomPanel').hide();
      view.remove('cBottomPanel-splitter');
      view.init();
      Core.init(view);
      Core.View.showDisconnect(true);
      Core.View.showToolbar(true);
        
      // Remove HVX's standard top bar
      Ext.getCmp('cButtonBar').ownerCt.destroy();
      Ext.getCmp('cMainComponent').setMargin(0);
      // wait for both app config and user pref to be loaded
      const configLoaded = new Promise((resolve)=>
        Core.EventManager.addListener('hvx.config.loaded',resolve)  
      );
      const userProfileLoaded = new Promise((resolve)=>
        Core.EventManager.addListener('hvx.user.profile.loaded',resolve)  
      );
        // Set hvx config callback
      Core.EventManager.addListener('hvx.config.loaded', () => {
        console.log('hvx.config.loaded');
        // Theme.load();
        const ol = MapModule.getOl();
        // Load data dependent modules
        MapModule.load({
          clickListener: true
        });
        // Default map centered on north carolina and zoomed to fit the atlantic seaboard
        const olMap = MapModule.getMap();

        // Change the position of the zoom control
        olMap.getControls().getArray()[0].element.style.left = '0.5em';

        // Add an overview map control, using the main map's baselayer
        const ovMapControl = new ol.control.OverviewMap({
          layers: [new ol.layer.Tile({
            source: olMap.getLayers().getArray()[0].getSource()
          })]
        });
        olMap.addControl(ovMapControl);

        // Add dragzoom control to ovmap but affect the main map
        const dragZoom = new ol.interaction.DragZoom();
        ovMapControl.getOverviewMap().addInteraction(dragZoom);
        dragZoom.setMap(olMap);

        olMap.addControl(new ol.control.ScaleLine({
          units: 'us'
        }));
          
        const mouseProj = ol.proj.get('EPSG:4326');
        olMap.addControl(new ol.control.MousePosition({
          projection: mouseProj,
          coordinateFormat: function(coordinate) {
            if (mouseProj.canWrapX()) {
              const projectionExtent = mouseProj.getExtent();
              const worldWidth = ol.extent.getWidth(projectionExtent);
              const x = coordinate[0];
              if (x < projectionExtent[0] || x > projectionExtent[2]) {
                const worldsAway = Math.ceil((projectionExtent[0] - x) / worldWidth);
                coordinate = [x + worldWidth * worldsAway, coordinate[1]];
              }
            }

            return ol.coordinate.format(coordinate, '{x}, {y}', 4);
          }
        }));

        const mapView = olMap.getView();
        let defaultCoords = [-8830005.507503562, 4233999.870772483];

        mapView.setCenter(defaultCoords);
        mapView.setZoom(5);

        Core.EventManager.addListener(UserProfile.PROFILE_LOADED, () => {
          const baseLocation = UserProfile.getBaseLocations();
          olMap.once('postrender', () => {
              
            theme.load().then(() => {
              theme.setTheme(UserProfile.getAppTheme());
            });

          });

          if (baseLocation) {
            try {
              const wktFormat = new ol.format.WKT();
              const blFeature = wktFormat.readFeature(baseLocation, {
                dataProjection: 'EPSG:3857',
                featureProjection: 'EPSG:3857'
              });

              if (blFeature) {
                defaultCoords = blFeature.getGeometry().getCoordinates();
              }
            } catch (e) {
              // couldn't convert baselocation into a ol feature
            }

            mapView.setCenter(defaultCoords);
            mapView.setZoom(5);
          }
        });
        Commands.load();
        DrawMenuModule.load();

        // GUI augmentations
        Sidebar.load();
        DataPanel.load();
        DataTree.load();
        Toolbar.load();
        Overhang.load();

        // Data views
        SloshExplorer.load();
        StormTrack.load();
        Graphs.load();
        TextAdvisory.load();
        CTTViewer.load();
        EvacuationDialog.load();
        SurgeViewer.load();
        Reports.load();
        TWOViewer.load();
        //   RiskProfiles.load();

        // Utilities
        Pins.load();
        GeocodeModule.load();
        PoiWindowModule.load();

        // Interactive overlays
        Tracker.load();
        Legend.load();
        ContextMenu.load();
        Forecast.load();
        Training.load();

        // Experimental features
        if (Core.Config.getProperty('hvx.experimentalFeatures') === 'true') {
          if (Core.Config.getProperty('hvx.experimental.riskprofile') === 'true') {
            RiskProfiles.load();
          }

          if (Core.Config.getProperty('hvx.experimental.stormsim') === 'true') {
            StormSim.load();
          }

        } 

        Core.EventManager.fireEvent('HVX.user.login', {
          userAgent: window.navigator.userAgent
        });


        Core.EventManager.addListener('change-basemap', () => {
          const mainMapLayer = olMap.getLayers().getArray()[0];
          const ovMapLayer = ovMapControl.getOverviewMap().getLayers().getArray()[0];
          ovMapLayer.setSource(mainMapLayer.getSource());
        });

      });

      Core.Config.httpLoad();
    });
    // end of the app
  });
  });
});